export default __webpack_public_path__ + "static/media/pic1.efc9376e.png";